<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('curveDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <!-- <label v-if="this.$parent.curveNotEmpty" class="form-label">{{ $t('curveNotEmpty') }}</label>
                    <template v-else-if="this.$parent.foundCurves.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteCurve') }}</label>
                        <div v-for="(curve, i) in this.$parent.foundCurves" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/modelingresult/' + curve.resultId ">
                                {{ curve.name }} - Id: {{curve.resultId}}
                            </RouterLink>
                        </div>
                    </template>-->

                    <p >{{ $t('wannaDeleteThisCurve') }}</p> 
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteCurve">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import CurveApi from "../../api/server/curve.js";

export default {
    name: "curveDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteCurve() {
            await CurveApi.curveDelete(this.$parent.$route.params.id, this.$parent.$route.params.curveId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
}
</script>